import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { blockedUsersFetchAction } from '../../../../store/fetchActions/blockedUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../../components/Filter/Filter.styles';
import TextInput from '../../../../components/TextInput/TextInput';
import DateInput from '../../../../components/DateInput/DateInput';
import Modal from '../../../../components/Modal/Modal';
import Button from '../../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import { theme } from '../../../../styles/theme';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import { LoadingContainer } from '../../styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import { translateMessage } from '../../../../utils/functions/translateMessage';
import { userFetchAction } from '../../../../store/fetchActions/usersActions';
import { perfisFetchAction } from '../../../../store/fetchActions/perfisActions';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import AboutCollum from '../Collums/AboutCollum';
import InformationCollum from '../Collums/InformationCollum';
import AddressCollum from '../Collums/AddressCollum';
import TaxCollum from '../Collums/TaxCollum';
import DocumentCollum from '../Collums/DocumentCollum';
import { yupResolver } from '@hookform/resolvers/yup';
import { editUserSchema } from '../../validation/usuariosAprovados.validation';
// import LegalRepresentative from '../Cards/LegalRepresentative';
import GraphicSheet from '../GraphicSheet';
import ModalPassword from '../../../../components/ModalPassword/ModalPassword';
import ModalBlockUser from '../Modals/BlockUser.jsx';
// import { unlockUserFetchAction } from '../../../../store/fetchActions/unlockUserActions';

const { mainColor, secondaryColor, rbmWhite, rbmBlack } = theme.colors;

function UsuariosBloqueados(props) {
  const dispatch = useDispatch();

  const { value, index } = props;

  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [isModalBlockUserOpen, setIsModalBlockUserOpen] = useState(false);

  const { handleSubmit, control } = useForm({
    // resolver: yupResolver(selectValidation),
  });

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
    orderBy: '',
    limit: 10,
    page: 1,
  });

  useCallFilter(filterData, setFilter, blockedUsersFetchAction, value, index);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const { usersData, loadingUser, errorUser, errorMessageUser } = useSelector(
    (state) => state.user
  );

  const {
    handleSubmit: handleUserData,
    control: controlUserForm,
    reset: resetUserForm,
    formState: { errors },
  } = useForm({ resolver: yupResolver(editUserSchema) });

  useEffect(() => {
    value === index && (() => dispatch(blockedUsersFetchAction(filter)))();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, value, index, filter.page]);

  useEffect(() => {
    resetUserForm(usersData);
  }, [usersData, resetUserForm]);

  const filterTable = (data) => {
    setFilterData(data);
  };

  function cancel() {
    setIsEditing(false);
    resetUserForm();
  }

  const openModalPassword = () => setIsModalPasswordOpen(true);
  const closeModalPassword = () => setIsModalPasswordOpen(false);

  const {
    blockedUsersData,
    paginationBlockedUsers,
    loadingBlockedUsers,
    errorBlockedUsers,
    errorMessageBlockedUsers,
  } = useSelector((state) => state.blockedUsers);

  const header = [
    { id: 'ID', name: 'ID', align: 'center' },
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    { id: 'CPFCNPJ', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    {
      id: 'observação',
      name: 'OBSERVAÇÃO',
      align: 'left',
    },
  ];

  const body = blockedUsersData?.map((user) => {
    return {
      data: [
        { info: user.ID, align: 'center' },
        { info: user.DATA_INSERT, align: 'center' },
        { info: user.CPFCNPJ, align: 'left' },
        { info: user.NOME, align: 'left' },
        { info: user.MENSAGEM, align: 'left' },
      ],
      // onClick: () => inspectUser(user.CPFCNPJ),
    };
  });

  function inspectUser(id) {
    dispatch(userFetchAction(id, 'willBeLoaded'));
    dispatch(perfisFetchAction());
    setIsModalInfoOpen(true);
  }

  const closeModalInfo = () => {
    setIsEditing(false);
    setIsModalInfoOpen(false);
  };

  return (
    <div hidden={value !== index}>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextInput
              label="Nome ou CPF/CNPJ"
              name={'search'}
              width={'38.042vw'}
              margin={'0 0 0 1.369vw'}
              control={control}
            />
            <DateInput
              label="Data Inicial"
              name={'DATAINICIAL'}
              control={control}
            />
            <DateInput
              label="Data Final"
              name={'DATAFINAL'}
              control={control}
            />

            <Button
              backgroundColor={secondaryColor}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverBGColor={mainColor}
              hoverColor={rbmBlack}
              color={'white'}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>

          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions
              control={control}
              options={pagesOptions}
              name={'limit'}
              width={'5vw'}
              margin={'0 0 0 1.875vw'}
              initialValue={10}
              initialName={10}
            />
            <h5>Total de resultados: {paginationBlockedUsers?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingBlockedUsers ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          loading={loadingBlockedUsers}
          error={errorBlockedUsers}
          hasPagination={true}
          filter={filter}
          pagination={paginationBlockedUsers}
          setFilter={setFilter}
          errorMessage={errorMessageBlockedUsers}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}

      <Modal
        open={isModalInfoOpen}
        close={closeModalInfo}
        title="Detalhes Usuário"
        width={'96.222vw'}
      >
        {loadingUser ? (
          <LoadingContainer marginTop={'1vw'}>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : errorUser ? (
          <h1>{translateMessage(errorMessageUser)}</h1>
        ) : (
          <>
            <Styled.EditButtonContainer>
              <h4>Informações Pessoais</h4>
              <Button
                backgroundColor={secondaryColor}
                width={'15.153vw'}
                height={'3.333vw'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={rbmWhite}
                onClick={() => {
                  !isEditing && openModalPassword();
                }}
              >
                <span>DESBLOQUEAR USUÁRIO</span>
              </Button>
            </Styled.EditButtonContainer>
            <Styled.FirstBlock>
              <InformationCollum />
              <form>
                <AboutCollum
                  control={controlUserForm}
                  isEditing={isEditing}
                  errors={errors}
                />
                <AddressCollum
                  control={controlUserForm}
                  isEditing={false}
                  block={false}
                  cancel={cancel}
                  errors={errors}
                />
              </form>
            </Styled.FirstBlock>
            {/* <LegalRepresentative /> */}
            <Styled.Line />
            <Styled.SecondBlock>
              <TaxCollum />
              <DocumentCollum />
            </Styled.SecondBlock>
            <Styled.Line />
            <Styled.ThirdBlock>{<GraphicSheet />}</Styled.ThirdBlock>
          </>
        )}
      </Modal>

      <ModalBlockUser
        openModal={isModalBlockUserOpen}
        closeModal={() => {
          setIsModalBlockUserOpen(false);
          setIsModalInfoOpen(false);
        }}
        blockUser={false}
        optionText={'desbloquear'}
        // optionAction={unlockUserFetchAction}
      />

      <ModalPassword
        openModal={isModalPasswordOpen}
        closeModal={closeModalPassword}
        nextFunction={() => setIsModalBlockUserOpen(true)}
      />
    </div>
  );
}

UsuariosBloqueados.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default memo(UsuariosBloqueados);
